import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Observable, take} from "rxjs";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";
import {OrderModel} from "../../models/order.model";
import {OrdersActions, OrdersAPiActions, OrdersChannelActions} from "../state/orders.action";
import {ordersFeature} from "../state/orders.state";
import {OmsOrdersQueryModel} from "../../models/oms-orders-query.model";

@Injectable()
export class OrdersFacadeService implements EntitiesFacade<OrderModel> {

  constructor(@Inject(Store) private store: Store<OrderModel>) {
  }

  clearStore(): void {
    this.store.dispatch(OrdersActions.clearStore());
  }

  createOne(entity: OrderModel): void {
  }

  deleteOne(id: string, shouldMask?: boolean): void {
  }

  fetchNext(query: OmsOrdersQueryModel, isSubscribeToChannel?: boolean): void {
    this.store.select(ordersFeature.selectNextPage()).pipe(take(1)).subscribe((nextPage) => {
      if (nextPage !== null) {
        this.store.dispatch(OrdersAPiActions.getInfiniteScrollOrders({
          query: query,
          isSubscribeToChannel: isSubscribeToChannel
        }));
      }
    })
  }

  getMany(query: OmsOrdersQueryModel, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(OrdersAPiActions.getOrders({query: query, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getInfiniteScrollEntities(query: OmsOrdersQueryModel, isSubscribeToChannels?: boolean): void {
    this.store.dispatch(OrdersAPiActions.getInfiniteScrollOrders({
      query: query,
      isSubscribeToChannel: isSubscribeToChannels
    }));
  }

  getOne(orderId: string, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(OrdersAPiActions.getOrder({orderId: orderId, isSubscribeToChannel: isSubscribeToChannel}));
  }

  removeAll(): void {
    this.store.dispatch(OrdersActions.removeAll());
  }

  removeByIds(ids: string[]): void {
    this.store.dispatch(OrdersActions.removeOrders({ids: ids}));
  }

  selectOne(id: string) {
    return this.store.select(ordersFeature.selectOrder(id));
  }

  selectByIds(ids: string[]): Observable<OrderModel[]> {
    return this.store.select(ordersFeature.selectOrdersById(ids));
  }

  selectAll(): Observable<OrderModel[]> {
    return this.store.select(ordersFeature.selectOrders());
  }

  selectInfiniteScrollEntities(): Observable<OrderModel[]> {
    return this.store.select(ordersFeature.selectInfiniteScrollOrders());
  }

  setMany(orders: OrderModel[], isAppendFirst?: boolean): void {
    this.store.dispatch(OrdersActions.setOrders({orders: orders, isAppendFirst: isAppendFirst}))
  }

  setInfiniteScrollOrders(orders: OrderModel[], isAppendFirst?: boolean) {
    this.store.dispatch(OrdersActions.setInfiniteScrollOrdersIds({
      orderIds: orders.map(o => o.id),
      isAppendFirst: isAppendFirst
    }));
    this.store.dispatch(OrdersActions.setOrders({orders: orders, isAppendFirst: isAppendFirst}))
  }

  setOne(entity: OrderModel): void {
  }

  subscribeToChannels(): void {
    this.store.dispatch(OrdersChannelActions.subscribe());
  }

  unsubscribeFromChannels(): void {
    this.store.dispatch(OrdersChannelActions.unsubscribe());
  }

  editOne(id: string, entity: OrderModel): void {
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(ordersFeature.selectIsLoading());
  }

  selectInitialized(): Observable<boolean> {
    return this.store.select(ordersFeature.selectInitialized());
  }

  updateOne(order: OrderModel): void {
  }

  updateMany(orders: OrderModel[]): void {
  }

}
